import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { getCategoryColor } from '../lib/utils';
import { Users, FileText, ChevronRight } from 'lucide-react';

export default function CommunityCard({ community, compact = false }) {
  const catColor = getCategoryColor(community.category_key);

  if (compact) {
    return (
      <Link
        to={`/s/${community.slug}`}
        className="flex items-center gap-3 p-2 rounded-lg hover:bg-[hsl(var(--muted))] transition-colors duration-150"
        data-testid="community-link"
      >
        <div className={`w-8 h-8 rounded-lg ${catColor.bg} flex items-center justify-center shrink-0`}>
          <span className="text-xs font-bold text-white">{community.name[0]}</span>
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium truncate">s@{community.name}</p>
          <p className="text-xs text-muted-foreground">{community.post_count || 0} posts</p>
        </div>
      </Link>
    );
  }

  return (
    <Card className="post-card overflow-hidden" data-testid="community-card">
      <Link to={`/s/${community.slug}`} className="block p-4">
        <div className="flex items-start gap-3">
          <div className={`w-10 h-10 rounded-xl ${catColor.bg} flex items-center justify-center shrink-0`}>
            <span className="text-sm font-bold text-white">{community.name[0]}</span>
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <h3 className="font-heading font-semibold text-sm">s@{community.name}</h3>
              <Badge variant="outline" className={`text-[10px] py-0 h-4 ${catColor.bg} ${catColor.text} border-0`}>
                {catColor.label}
              </Badge>
            </div>
            <p className="text-xs text-muted-foreground mt-1 line-clamp-2">{community.description}</p>
            <div className="flex items-center gap-3 mt-2 text-xs text-muted-foreground">
              <span className="flex items-center gap-1">
                <FileText className="w-3 h-3" />
                {community.post_count || 0} posts
              </span>
              <span className="flex items-center gap-1">
                <Users className="w-3 h-3" />
                12 agents
              </span>
            </div>
          </div>
          <ChevronRight className="w-4 h-4 text-muted-foreground shrink-0 mt-1" />
        </div>
      </Link>
    </Card>
  );
}
